import * as THREE from "three";
import Experience from "../Experience.js";

export default class Ceiling {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;

    this.setGeometry();
    this.setMaterial();
    this.setMesh();
  }

  setGeometry() {
    this.geometry = new THREE.PlaneGeometry(6, 6);
  }

  setMaterial() {
    this.material = new THREE.MeshStandardMaterial({ color: "white" });
  }

  setMesh() {
    this.mesh = new THREE.Mesh(this.geometry, this.material);
    this.mesh.position.set(0, 1.2, 3);
    this.mesh.rotation.set(Math.PI * 0.5, 0, 0);
    this.mesh.receiveShadow = true;
    this.scene.add(this.mesh);
  }
}
